import React from 'react';

const CorporateActivities = () => {
  const activities = [
    { title: 'Annual General Meeting', date: 'January 2026' },
    { title: 'Board Retreat', date: 'March 2026' },
    { title: 'Strategic Planning Session', date: 'May 2026' },
    { title: 'Stakeholder Engagement', date: 'July 2026' },
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Corporate Activities</h1>
        <p>Our ongoing corporate initiatives</p>
      </section>
      <section className="page-content">
        <div className="container">
          {activities.map((activity, index) => (
            <div className="activity-item" key={index}>
              <h3>{activity.title}</h3>
              <p>{activity.date}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default CorporateActivities;